'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.515 9.6a.9.9 0 0 0 0 1.8H9.1v7.586a.9.9 0 0 0 1.8 0V11.4h7.585a.9.9 0 0 0 0-1.8H10.9V2.015a.9.9 0 0 0-1.8 0V9.6z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
